class AccessDenied extends HTMLElement {
  connectedCallback() {
    this.initVariables();
    this.initEventListeners();
    this.denyEntry();
  }

  initVariables() {
    this.accessDeniedModal = this.querySelector('[data-access-denied-dialog]');
  }

  initEventListeners() {
    if (!this.accessDeniedModal) {
      return;
    }
    this.accessDeniedModal.addEventListener('cancel', event => {
      event.preventDefault();
      globalThis.location.replace(Shopify.routes.root);
    });
  }

  /**
   * Shows the access denied modal
   * @returns {void}
   */
  async denyEntry() {
    if (!this.accessDeniedModal) return;

    this.accessDeniedModal.inert = true;
    this.accessDeniedModal.showModal();
    this.accessDeniedModal.inert = false;
  }
}

customElements.get('access-denied') ||
  customElements.define('access-denied', AccessDenied);
